<template>
  <el-tooltip placement="top">
    <div slot="content">Фильтр по валюте</div>
    <el-select
      :value="value"
      value-key="_id"
      :placeholder="placeholder"
      clearable
      filterable
      :loading="loading"
      @change="onChange"
    >
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
  </el-tooltip>
</template>
<script>
import { getLedgerValutes } from "@/api";

export default {
  name: "SelectValute",
  props: {
    value: {
      type: String
    },
    placeholder: {
      type: String,
      default: "Валюта"
    }
  },
  data() {
    return {
      rawOptions: [],
      loading: true
    };
  },
  computed: {
    options() {
      return this.rawOptions.map(option => {
        return {
          label: option.name,
          value: option._id
        };
      });
    }
  },
  methods: {
    onChange(val) {
      // this.$emit("change", val);
      this.$emit("input", val);
    }
  },
  async mounted() {
    this.loading = true;
    const res = await getLedgerValutes({ paginate: false });
    this.rawOptions = res.data.result.docs;
    this.loading = false;
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/ui/SelectValute.vue